import type { HttpErrorResponse } from '@angular/common/http';

import { createActions, ngrxEvent } from '@recruitee/ngrx';
import type { Candidate } from '@recruitee/viewbox-candidates-data';

const namespace = 'viewboxNotes';

export const ViewboxNotesActions = createActions(namespace, {
  delete: ngrxEvent<number>(),
  deleteSuccess: ngrxEvent<{ note: Candidate.Note }>(),
  deleteFailed: ngrxEvent<{ error: HttpErrorResponse }>(),
  save: ngrxEvent<{
    candidateId: number | null;
    data: Partial<Candidate.Note>;
  }>(),
  saveSuccess: ngrxEvent<{ note: Candidate.Note }>(),
  saveFailed: ngrxEvent<{ error: HttpErrorResponse }>(),
});
